<article
  *transloco="let t"
  appearance="outline"
  class="flex flex-1 flex-col gap-2.5! *:not-first:border-t *:not-first:border-border-tertiary"
  tuiCardLarge>
  <header class="flex flex-wrap items-center justify-between gap-2">
    <p class="text-balance text-sm text-text-tertiary" data-testid="date-author">
      {{t('{{ date }} à {{ time }}', { date: telemonitoring.telemonitoring.createdOn | date: 'mediumDate', time:
      telemonitoring.telemonitoring.createdOn | date: 'shortTime' }) }}
      @if (telemonitoring.createdByInstance) {
        <span class="mx-1 text-border-normal" data-testid="author-separator">•</span>
        <pxc-user-preview [colored]="false" [user]="telemonitoring.createdByInstance" />
      }
    </p>

    <div class="flex flex-wrap gap-3 text-sm!">
      <button data-appearance="primary" data-testid="qr-code" tuiLink type="button" (click)="openQrCodeInGallery()">
        {{ t('QR Code') }}
      </button>
      @if (actions) {
        <pxc-action-buttons
          data-testid="actions"
          [actions]="actions"
          [entity]="telemonitoring"
          [optionButtonLabel]="t('Options')" />
      }
    </div>
  </header>

  <section class="flex cursor-pointer select-none gap-3 pt-2.5 max-sm:flex-col" (click)="clicked.emit()">
    <div class="relative h-20 w-20 shrink-0">
      @if (!telemonitoring.previewMedia) {
        <pxc-image-broken />
      } @else {
        <pxc-sequence-media alt="Aperçu du télésuivi" data-testid="thumbnail" [media]="telemonitoring.previewMedia" />
      }
      <span class="absolute bottom-1 right-1">
        <span appearance="brand" data-testid="telemonitoring-badge" iconStart="telemonitoring" size="l" tuiBadge></span>
      </span>
    </div>

    <div class="grid flex-1 gap-3 lg:grid-cols-2">
      <div class="flex flex-col pt-1 gap-1">
        <div class="flex flex-wrap items-center gap-x-2">
          <p class="line-clamp-2 text-lg font-medium leading-snug" data-testid="name">
            {{ telemonitoring | telemonitoringName }}
          </p>
          @if (telemonitoring.telemonitoring.isArchived) {
            <pxc-archived-badge />
          }
        </div>
        @if (telemonitoring.telemonitoring.lastActivity; as lastActivity) {
          <span appearance="neutral" tuiBadge tuiStatus>
            {{ lastActivity | lastActivity }}
          </span>
        }
        <p class="text-sm text-text-tertiary mt-0.5" data-testid="sequences-count">
          {{
            t('{ count, plural, =1 {# séquence} other {# séquences} }', {
              count: telemonitoring.telemonitoring.sequenceCount,
            })
          }}
        </p>
      </div>

      @if (displayPatient) {
        <div class="flex gap-3">
          <pxc-patient-avatar class="shrink-0" data-testid="avatar" size="small" [patient]="telemonitoring.patient" />
          <pxc-patient-data class="grow" data-testid="patient" size="small" [patient]="telemonitoring.patient" />
        </div>
      }
    </div>
  </section>
</article>
